import "@polymer/polymer/lib/elements/dom-if.js";
import "@polymer/polymer/lib/elements/dom-repeat.js";
import { html, PolymerElement } from "@polymer/polymer/polymer-element.js";

import iconArrowDownBlue from "../../../../images//icons/icon_arrow_down_blue.svg";
import iconArrowUpBlue from "../../../../images/icons/icon_arrow_up_blue.svg";

import "./EcourseListNarasumber.style";

class EcourseListNarasumber extends PolymerElement {
  static get template() {
    return html`
      <style include="ecourse-list-narasumber-style"></style>
      <div>
        <div class="container" id="container-card">
          <template is="dom-if" if="{{!isShowFull}}">
            <dom-repeat items="{{narasumber}}" as="list">
              <template>
                <div class="container-content">
                  <img src="{{list.profile_picture_url}}" />
                  <div>
                    <h2>{{list.name}}</h2>
                    <div class="content-text" inner-h-t-m-l="{{list.description}}"></div>
                  </div>
                </div>
              </template>
            </dom-repeat>
          </template>
          <template is="dom-if" if="{{isShowFull}}">
            <dom-repeat items="{{listNarasumber}}" as="list">
              <template>
                <div class="container-content">
                  <img src="{{list.profile_picture_url}}" />
                  <div>
                    <h2>{{list.name}}</h2>
                    <div class="content-text" inner-h-t-m-l="{{list.description}}"></div>
                  </div>
                </div>
              </template>
            </dom-repeat>
          </template>
        </div>
        <template is="dom-if" if="{{isButtonShow}}">
          <template is="dom-if" if="{{!isShowFull}}">
            <div on-click="onShowFull" class="container-lainnya">
              Lihat Narasumber Lainnya
              <img src="[[iconArrowDownBlue]]" style="margin-top: 3px; margin-left: 9px;" />
            </div>
          </template>
          <template is="dom-if" if="{{isShowFull}}">
            <div on-click="onShowFull" class="container-lainnya">
              Sembunyikan
              <img src="[[iconArrowUpBlue]]" style="margin-top: 3px; margin-left: 9px;" />
            </div>
          </template>
        </template>
      </div>
    `;
  }

  ready() {
    super.ready();
    if (this.listNarasumber.length > 3) {
      this.narasumber = this.listNarasumber.slice(0, 3);
      this.isButtonShow = true;
    } else {
      this.narasumber = this.listNarasumber;
      this.isButtonShow = false;
    }
  }

  static get properties() {
    return {
      listNarasumber: {
        type: Array,
      },
      narasumber: {
        type: Array,
        value: [],
        notify: true,
      },
      iconArrowDownBlue: {
        type: String,
        value: iconArrowDownBlue,
      },
      iconArrowUpBlue: {
        type: String,
        value: iconArrowUpBlue,
      },
      isShowFull: {
        type: Boolean,
        value: false,
      },
      isButtonShow: {
        type: Boolean,
        value: false,
      },
    };
  }

  onShowFull() {
    if (this.isShowFull) {
      this.isShowFull = false;
    } else {
      this.isShowFull = true;
    }
  }
}
customElements.define("ecourse-list-narasumber", EcourseListNarasumber);
